<template>
    <div>
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Contract Timeline</h2>
        <div class="rounded-xl m-0 mt-2 p-2 border border-gray-200 bg-gray-50" v-if="contractedWorks">
            <div class="flex m-0">
                <div class="w-6 flex">
                    <div class="w-2 border-r-2 border-blue-600"></div>
                    <div class="flex-grow flex flex-row w-6">
                        <div class="flex-grow border-b-2 border-blue-600" style="height:50%"></div>
                    </div>
                </div>
                <div
                    class="flex-grow my-1 pl-2 py-1 rounded-l-2xl text-xs cursor-pointer"
                    :class="(currentViewing==='proposal'?' border-2 border-blue-600 bg-gray-50':' border-2 border-gray-200 bg-white hover:bg-gray-50')+(contractedWorks.proposal?' text-gray-700':' text-gray-400')"
                    @click="$emit('proposalSelected')">
                    <div class="flex">
                        <div class="flex-grow text-sm font-semibold mb-1">Proposed Changes</div>
                        <div class="mr-3 mt-0" v-if="(currentViewing==='proposal') && contractedWorks.proposal">
                            <ui-button-new icon="fa fa-trash" small @click="$emit('proposalCleared');"></ui-button-new>
                        </div>
                    </div>
                    <div class="flex">
                        <div v-if="contractedWorks.proposal"
                             v-bind:title="contractedWorks.proposal.lastUpdatedBy?contractedWorks.proposal.lastUpdatedBy:contractedWorks.proposal.createdBy"
                             v-text="'Last Edited: ' + (contractedWorks.proposal.lastUpdatedOn?moment(contractedWorks.proposal.lastUpdatedOn).format('Do MMMM YYYY, h:mm a'):moment(contractedWorks.proposal.createdOn).format('Do MMMM YYYY, h:mm a'))"></div>
                        <div v-else>No changes proposed</div>
                    </div>
                    <div class="w-full flex justify-center mt-3 mb-1.5"
                         v-if="(currentViewing==='proposal') && contractedWorks.proposal">
                        <ui-button-new small primary @click="$emit('proposalAccept')">Accept Proposal</ui-button-new>
                    </div>
                </div>
            </div>
            <div class="flex m-0" v-for="variation in sortedVariations">
                <div class="w-6 flex">
                    <div class="w-2 border-r-2 border-blue-600"></div>
                    <div class="flex-grow flex flex-row w-6">
                        <div class="flex-grow border-b-2 border-blue-600" style="height:50%"></div>
                    </div>
                </div>
                <div
                    class="flex-grow my-1 pl-2 py-1 rounded-l-2xl text-xs cursor-pointer truncate"
                    :class="currentViewing===variation.id?' border-2 border-blue-600 bg-gray-50':' border-2 border-gray-200 bg-white hover:bg-gray-50'"
                    @click="$emit('variationSelected',variation.id)">
                    <div class="text-sm font-semibold truncate mb-1"
                         v-text="variation.name.trim()?variation.name.trim():('Variation '+variation.variationNumber)"></div>
                    <div class="flex w-full">
                        <div class="flex-grow"
                             v-bind:title="variation.lastUpdatedBy?variation.lastUpdatedBy:variation.createdBy"
                        >{{ moment(variation.acceptedAt).format('Do MMMM YYYY, h:mm a') }}
                        </div>
                        <div class="flex-shrink text-right font-semibold mr-2">V{{ variation.variationNumber }}</div>
                    </div>
                </div>
            </div>
            <div class="flex m-0" v-if="contractedWorks.initialContract">
                <div class="w-6 flex">
                    <div class="w-2 border-r-2 border-blue-600"></div>
                    <div class="flex-grow flex flex-row w-6">
                        <div class="flex-grow border-b-2 border-blue-600" style="height:50%"></div>
                    </div>
                </div>
                <div
                    class="flex-grow my-1 pl-2 py-1 rounded-l-2xl text-xs cursor-pointer"
                    :class="currentViewing==='initial'?' border-2 border-blue-600 bg-gray-50':' border-2 border-gray-200 bg-white hover:bg-gray-50'"
                    @click="$emit('initialContractSelected')">
                    <div class="text-sm font-semibold mb-1">Initial Contract</div>
                    <div
                        v-bind:title="contractedWorks.initialContract.lastUpdatedBy?contractedWorks.initialContract.lastUpdatedBy:contractedWorks.initialContract.createdBy"
                    >{{ moment(contractedWorks.initialContract.acceptedAt).format('Do MMMM YYYY, h:mm a') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import UiButton from "../../ui/UiButton.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import moment from "moment";
import contacts from "../../contacts/Contacts.vue";

export default {
    components: {UiButtonNew, UiButton},
    props: {
        contractedWorks: Object,
        currentViewing: String,
    },
    data() {
        return {
            moment
        }
    },
    watch: {},
    computed: {
        contacts() {
            return contacts
        },
        sortedVariations() {
            if (this.contractedWorks.variations) {
                return this.contractedWorks.variations.toSorted((a, b) => b.variationNumber - a.variationNumber);
            }
            return [];
        },
    },
    methods: {},
    mounted() {
    }
}
</script>
